// API of the multi-tenant package "popups" (owner 2026-10-03: every outbound email opens an editor
// first): the Taken/Return resend editor, the Due Diligence link email editor and the job
// status-confirm popup's edited send.
import { apiRequest } from '../api';

export interface EmailDraft { from: string; to: string[]; cc: string[]; subject: string; bodyHtml: string }

export const popupsApi = {
  // Taken/Return: the corrected notice exactly as the one-click resend sent it, then the edited copy on the same thread.
  trResendPrepare: (id: string): Promise<EmailDraft & { correction: boolean; inReplyTo: string; priorSentAt: string }> =>
    apiRequest('GET', `/taken-return/${id}/resend-prepare`),
  trResendSend: (id: string, d: { to: string; cc: string; subject: string; bodyHtml: string }): Promise<{ ok: true; to: string }> =>
    apiRequest('POST', `/taken-return/${id}/resend-send`, d),
  // Due Diligence: the link email as the send builds it; a client link is a placeholder until Send mints it.
  ddLinkPrepare: (id: string, q: { mode: 'edit' | 'view'; name: string; clientName: string; propName: string }):
    Promise<{ from: string; cc: string[]; subject: string; bodyHtml: string; linkPlaceholder: string }> =>
    apiRequest('GET', `/due-diligence/${id}/email-link/prepare?${new URLSearchParams(q as any).toString()}`),
  ddLinkSend: (id: string, b: { email: string; name: string; clientName: string; propName: string; mode: 'edit' | 'view'; subject: string; bodyHtml: string }):
    Promise<{ ok: true; sent: string; cc: string }> => apiRequest('POST', `/due-diligence/${id}/email-link`, b),
  // Job status confirm: the existing confirm call carrying the popup's edited email. draftSig = the
  // draft the fields were filled from; bodyHtml only once edited (untouched, the server renders it fresh).
  jobConfirmSend: (id: string, b: {
    to: string[]; cc: string[]; subject: string; bodyHtml?: string; draftSig: string;
    withDocs?: boolean; extraHtml?: string; fileIds?: string[]; calendarPlan?: { calendar?: string; items: any[] };
  }): Promise<any> => apiRequest('POST', `/jobs/status-confirm/${id}/confirm`, b),
};

// A typed address list (comma / semicolon / space separated) → the valid addresses, each once (case kept).
export function splitEmails(s: string): string[] {
  const seen = new Set<string>(); const out: string[] = [];
  for (const x of String(s || '').split(/[,;\s]+/)) {
    const e = x.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e) || seen.has(e.toLowerCase())) continue;
    seen.add(e.toLowerCase()); out.push(e);
  }
  return out;
}
